module.exports = __webpack_public_path__ + "static/media/PONGATE_Logo-Claim_460x180.0867ad3f.png";